module.exports = __webpack_public_path__ + "img/banner-mobile.b81919e7.jpg";